// components
import FormValidation from '@/js/components/forms/formValidation';

class ContactPage {
  constructor() {
    this.dom = {
      formContact: document.getElementById('form-contact'),
      alertScroll: document.querySelector('.js-alert-scroll:not(.d-none)'),
    };

    this.components = {
      contactFormValidation: null,
    };

    this.mount();
  }

  mount() {
    if (this.dom.formContact) {
      this.components.contactFormValidation = new FormValidation(this.dom.formContact);
    }

    if (this.dom.alertScroll) {
      this.dom.alertScroll.scrollIntoView({ behavior: 'smooth' });
    }
  }
}

if (document.getElementById('page-contact')) {
  // eslint-disable-next-line no-new
  new ContactPage();
}
